<template>
  <div class="mt-[30px] invoice-detail">
    <a-form
      ref="formRef"
      :hideRequiredMark="true"
      :model="formState"
      layout="vertical"
    >
      <template v-if="route.query.id">
        <div class="order-detail-title">{{ $t('ding-dan-xin-xi') }}</div>
        <a-spin :spinning="loading">
          <SingleOrder :signal-order="signalOrder" />
        </a-spin>
      </template>
      <div class="order-detail-title">{{ $t('fa-piao-lei-xing') }}</div>
      <a-form-item name="invoice_type">
        <a-radio-group v-model:value="formState.invoice_type" name="radioGroup">
          <template v-for="item in invoiceTypes" :key="item.key">
            <a-radio
              :disabled="
                item.key === INVOICE_TYPE.VAT && (isPerson || !isVerify)
              "
              :value="item.key"
              :title="
                item.key === INVOICE_TYPE.VAT && isPerson
                  ? $t('ge-ren-yong-hu-jin-zhi-chi-kai-ju-pu-tong-fa-piao')
                  : isVerify
                  ? ''
                  : $t(
                      'ren-zheng-wan-cheng-hou-ke-kai-ju-zeng-zhi-shui-zhuan-yong-fa-piao'
                    )
              "
            >
              {{ item.label }}
            </a-radio>
          </template>
        </a-radio-group>
      </a-form-item>
      <template v-if="!route.query.id">
        <div class="order-detail-title flex justify-between">
          {{ $t('ke-kai-piao-ding-dan') }}
          <span
            v-if="formState.order_ids.length"
            class="text-font-60 text-14 ml-[5px]"
          >
            <span class="text-font-1">
              {{ $t('zong-jin-e') }}：{{
                formatPrice(totalPrice || 0, 'CNY').string
              }}
            </span>
            <a-divider type="vertical" />
            {{
              $t('yi-xuan-statecheckedlistlength-ge', [
                formState.order_ids.length,
              ])
            }}
          </span>
        </div>
        <a-form-item
          name="order_ids"
          :rules="[
            {
              required: true,
              message: $t('qing-xuan-ze-ding-dan'),
            },
          ]"
        >
          <a-table
            rowKey="no"
            :columns="columns"
            :dataSource="list"
            :loading="loading"
            :pagination="false"
            :rowSelection="rowSelection"
            :scroll="{ y: 'calc(100vh - 435px)' }"
          >
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'pay_type'">
                {{ PAY_TYPE_MAP().get(record.pay_type) }}
              </template>
              <template v-else-if="column.key === 'pay_fee'">
                {{ formatPrice(record.pay_fee, record.currency).string }}
              </template>
              <template v-else-if="column.key === 'total_fee'">
                {{ formatPrice(record.total_fee, record.currency).string }}
              </template>
            </template>
          </a-table>
        </a-form-item>
      </template>
      <div class="order-detail-title mt-[15px]">{{ $t('fa-piao-xin-xi') }}</div>
      <div class="flex gap-[20px]">
        <a-form-item
          :label="
            formState.invoice_type === INVOICE_TYPE.NORMAL
              ? `${$t('gong-si-tai-tou')}/${$t('ge-ren-xing-ming')}`
              : $t('gong-si-tai-tou')
          "
          :name="
            formState.invoice_type === INVOICE_TYPE.NORMAL
              ? 'ident_name'
              : 'ident_name_vat'
          "
          :rules="[
            {
              required: true,
              message:
                formState.invoice_type === INVOICE_TYPE.NORMAL
                  ? $t('qing-shu-ru-gong-si-tai-tou-ge-ren-xing-ming')
                  : $t('qing-shu-ru-gong-si-tai-tou'),
            },
          ]"
        >
          <a-input
            v-if="formState.invoice_type === INVOICE_TYPE.NORMAL"
            v-model:value="formState.ident_name"
            class="w-[300px]"
            :maxlength="50"
            :placeholder="$t('qing-shu-ru-gong-si-tai-tou-ge-ren-xing-ming')"
          />
          <a-input
            v-else
            v-model:value="formState.ident_name_vat"
            :maxlength="50"
            class="w-[300px]"
            :placeholder="$t('qing-shu-ru-gong-si-tai-tou')"
          />
        </a-form-item>
        <a-form-item
          v-if="formState.invoice_type === INVOICE_TYPE.VAT"
          name="ident_code_vat"
          :label="
            $t(
              'na-shui-ren-shi-bie-hao-she-hui-tong-yi-she-hui-xin-yong-dai-ma'
            )
          "
          :rules="[
            {
              required: true,
              message: $t(
                'qing-shu-ru-na-shui-ren-shi-bie-hao-she-hui-tong-yi-she-hui-xin-yong-dai-ma'
              ),
            },
          ]"
        >
          <a-input
            v-model:value="formState.ident_code_vat"
            :maxlength="50"
            :placeholder="
              $t(
                'qing-shu-ru-na-shui-ren-shi-bie-hao-she-hui-tong-yi-she-hui-xin-yong-dai-ma'
              )
            "
            class="w-[300px]"
          />
        </a-form-item>
        <a-form-item
          v-else
          name="ident_code"
          :label="`${$t(
            'na-shui-ren-shi-bie-hao-she-hui-tong-yi-she-hui-xin-yong-dai-ma'
          )}(${$t('xuan-tian')})`"
        >
          <a-input
            v-model:value="formState.ident_code"
            :maxlength="50"
            :placeholder="
              $t(
                'qing-shu-ru-na-shui-ren-shi-bie-hao-she-hui-tong-yi-she-hui-xin-yong-dai-ma'
              )
            "
            class="w-[300px]"
          />
        </a-form-item>
        <a-form-item
          :label="$t('dian-zi-you-xiang')"
          :name="
            formState.invoice_type === INVOICE_TYPE.NORMAL
              ? 'receiver_email'
              : 'receiver_email_vat'
          "
          :rules="[
            { required: true, message: $t('qing-shu-ru-you-xiang') },
            {
              pattern: emailReg,
              message: $t('qing-shu-ru-zheng-que-de-you-xiang-ge-shi'),
              trigger: 'blur',
            },
          ]"
        >
          <a-input
            v-if="formState.invoice_type === INVOICE_TYPE.NORMAL"
            v-model:value="formState.receiver_email"
            :placeholder="$t('qing-shu-ru-dian-zi-you-xiang')"
            class="w-[300px]"
          />
          <a-input
            v-else
            v-model:value="formState.receiver_email_vat"
            :placeholder="$t('qing-shu-ru-dian-zi-you-xiang')"
            class="w-[300px]"
          />
        </a-form-item>
      </div>
      <div class="text-center mt-[20px] pb-[20px]">
        <a-button
          type="primary"
          size="large"
          class="w-[282px]"
          @click="onSubmit"
        >
          {{ $t('que-ren-ti-jiao') }}
        </a-button>
      </div>
    </a-form>
    <CheckModal
      ref="modalRef"
      :title="$t('ti-jiao-kai-piao-shen-qing')"
      :width="656"
      :success="isSuccess"
      @submit="onSendInfo"
    />
  </div>
</template>

<script lang="ts" setup>
import CheckModal from './checkModal.vue'
import SingleOrder from './singleOrder.vue'
import { invoiceList, invoiceUserInfo, applyInvoice } from '~/api/index'
import { usePage } from '~/hooks/usePage'
import { PAY_TYPE_MAP } from '~/constants'
import { PageKey } from '~/constants/page'
import type { IOrder } from '~/api/interface/order'

interface FormState {
  invoice_type: number
  ident_code: string
  ident_code_vat: string
  ident_name: string
  receiver_email: string
  order_ids: string[]
  ident_name_vat: string
  receiver_email_vat: string
}
const invoiceIds = useInvoiceIds()
const route = useRoute()
const formRef = ref()
const formState: FormState = reactive({
  invoice_type: 0,
  ident_code: '',
  ident_code_vat: '',
  ident_name_vat: '',
  receiver_email_vat: '',
  ident_name: '',
  receiver_email: '',
  order_ids: route.query.id ? [route.query.id] : [],
})
const invoiceTypes = useDicts('invoiceType')
const { $t } = useNuxtApp()
const modalRef = ref()
const isSuccess = ref(false)
const totalPrice = ref()

defineProps<{
  isPerson: boolean
  isVerify: boolean
}>()

const columns = [
  {
    title: $t('ding-dan-hao'),
    dataIndex: 'no',
    key: 'no',
    width: 200,
  },
  {
    title: $t('shang-pin-xin-xi'),
    dataIndex: 'rights_name',
    key: 'rights_name',
    width: 120,
  },
  {
    title: $t('ding-dan-jin-e'),
    dataIndex: 'total_fee',
    key: 'total_fee',
    width: 100,
  },
  {
    title: $t('kai-piao-jin-e'),
    dataIndex: 'pay_fee',
    key: 'pay_fee',
    width: 100,
  },
  {
    title: $t('zhi-fu-fang-shi'),
    key: 'pay_type',
    width: 200,
  },
]

watch(
  () => formState.invoice_type,
  () => {
    formState.order_ids = route.query.id
      ? ([route.query.id] as string[])
      : rowSelection.value.selectedRowKeys
    totalPrice.value = list?.value
      ?.filter((o: any) => formState.order_ids.includes(o.no))
      ?.map((o: any) => o.pay_fee)
      ?.reduce((a: number, b: number) => a + b, 0)
  }
)

const rowSelection = ref({
  onChange: (selectedRowKeys: string[], selectedRows: any) => {
    formState.order_ids = selectedRowKeys
    rowSelection.value.selectedRowKeys = selectedRowKeys

    totalPrice.value = selectedRows
      ?.filter((o: any) => formState.order_ids.includes(o.no))
      ?.map((o: any) => o.pay_fee)
      ?.reduce((a: number, b: number) => a + b, 0)
  },
  selectedRowKeys: formState.order_ids,
})

const { list, total, page, page_size, loading, getList, reload } =
  usePage<IOrder>({
    api: async (params) => {
      const res: any = await invoiceList({
        ...params,
        no_in: invoiceIds.value?.toString() || route.query.id,
        many: 1,
      })
      if (!res?.data?.length) {
        const router = useRouter()
        router.push({
          name: PageKey.CENTER_ORDER,
        })
        return
      }

      return {
        ...res,
        data: {
          results: res.data,
        },
      }
    },
  })

const signalOrder: any = computed(() => list.value?.[0] || {})

const onSubmit = async () => {
  await formRef.value?.validateFields()

  try {
    modalRef.value?.toggle?.()
  } catch (error) {
    console.error(error)
  }
}

// 提交申请
const onSendInfo = async () => {
  try {
    const order_ids =
      (formState?.order_ids?.length && formState.order_ids) ||
      ([route.query.id] as string[])

    trackEvent(TRACK_EVENT.SUBMIT_ORDER_APPLY, {
      orderform: order_ids.join(','),
      type: formState.invoice_type,
      price: totalPrice.value,
    })

    const res = await applyInvoice({
      invoice_type: formState.invoice_type,
      order_ids:
        (formState?.order_ids?.length && formState.order_ids) ||
        ([route.query.id] as string[]),
      ident_name:
        formState.invoice_type === INVOICE_TYPE.NORMAL
          ? formState.ident_name
          : formState.ident_name_vat,
      receiver_email:
        formState.invoice_type === INVOICE_TYPE.NORMAL
          ? formState.receiver_email
          : formState.receiver_email_vat,
      ident_code:
        formState.invoice_type === INVOICE_TYPE.NORMAL
          ? formState.ident_code
          : formState.ident_code_vat,
    })

    if (!res.code && res.data) {
      isSuccess.value = true
    }
  } catch (e) {}
}

// 欲填充输入框内容
const fetchUserInvoice = async () => {
  const userInvoiceRes = await invoiceUserInfo()

  const result = userInvoiceRes?.data

  if (result?.length) {
    const normalBase: any = result.find(
      (o) => o.invoice_type === INVOICE_TYPE.NORMAL
    )
    formState.ident_name = normalBase?.ident_name
    formState.receiver_email = normalBase?.receiver_email
    formState.ident_code = normalBase?.ident_code
    const vatBase: any = result.find((o) => o.invoice_type === INVOICE_TYPE.VAT)
    formState.ident_name_vat = vatBase?.ident_name
    formState.receiver_email_vat = vatBase?.receiver_email
    formState.ident_code_vat = vatBase?.ident_code
  }
}
fetchUserInvoice()

onMounted(() => {
  reload()
})
</script>

<style lang="scss" scoped>
.invoice-detail {
  .ant-radio-group {
    background: none;
  }
  .order-detail-title {
    @apply text-16 font-medium mb-[20px];
  }

  :deep(.ant-form-item) {
    .ant-form-item-label > label::before {
      display: none;
    }
  }
}
</style>
